<div class="footLink"><a [routerLink]="['/contact-us']">Privacy Policy</a>
    <a [routerLink]="['/contact-us']">Terms of Services</a> 
    <a [routerLink]="['/contact-us']">Contact Us</a>
</div>
